export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";